document.addEventListener("DOMContentLoaded", () => {
    jQuery(function ($) {
        var page = 2;
        var loading = false;
        var max_pages = blog_load_more.max_pages;

        $(document).on("click", "#load-more-posts", function () {
            if (!loading && page <= max_pages) {
                loading = true;
                $(this).find("span").text("Se încarcă...");

                var data = {
                    action: "load_more_posts",
                    page: page,
                    posts_per_page: blog_load_more.posts_per_page,
                };

                $.post(blog_load_more.ajaxurl, data, function (response) {
                    if (response) {
                        $("#blog-loop").append(response);
                        page++;
                        loading = false;
                        $("#load-more-posts span").text("Mai multe articole");
                        if (page > max_pages) {
                            $("#load-more-posts").parent().hide();
                        }
                    } else {
                        $("#load-more-posts").parent().hide();
                    }
                });
            }
        });
    });
});
